module.exports = __webpack_public_path__ + "img/empty.865da859.png";